import mutationsTypes from '@/vuex/relatorios/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_LISTA_UNIDADES_PROCEDENCIA: 'GET_LISTA_UNIDADES_PROCEDENCIA',
  GERAR_PDF_GUIA_REMESSA_MALOTE: 'GERAR_PDF_GUIA_REMESSA_MALOTE',
  GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR: 'GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR'
}

export default types
